import {CookieConsentModalActionType} from 'analytics/CookieConsentModalReduxActions';
import {BenchlingAction} from 'redux-stores/Action';

export interface CookieConsentModalState {
  isOpen: boolean;
}

const INITIAL_STATE: CookieConsentModalState = {
  isOpen: false,
};

export default function reduceCookieConsentModal(
  state: CookieConsentModalState = INITIAL_STATE,
  action: BenchlingAction
): CookieConsentModalState {
  switch (action.type) {
    case CookieConsentModalActionType.COOKIE_CONSENT_MODAL_OPEN:
      return {...state, isOpen: true};
    case CookieConsentModalActionType.COOKIE_CONSENT_MODAL_CLOSE:
      return {...state, isOpen: false};
    default:
      return state;
  }
}
